import axios from "axios";
import { t } from '@mp/locale';
var countriesRoot = "/api/v7/address/countries";
export function getCountries() {
    return axios
        .get(countriesRoot)
        .then(function (response) { return response.data.service_countries; })
        .catch(function (error) {
        console.error(error);
    });
}
export function getAddressInfoByCountryCode(countryCode) {
    return axios
        .get("/api/v7/address/".concat(countryCode, "/format"))
        .then(function (response) { return response.data; });
}
var CountryCodeLookupTable = {
    AD: t("COMMON.COUNTRIES.AD"),
    AE: t("COMMON.COUNTRIES.AE"),
    AF: t("COMMON.COUNTRIES.AF"),
    AG: t("COMMON.COUNTRIES.AG"),
    AI: t("COMMON.COUNTRIES.AI"),
    AL: t("COMMON.COUNTRIES.AL"),
    AM: t("COMMON.COUNTRIES.AM"),
    AO: t("COMMON.COUNTRIES.AO"),
    AQ: t("COMMON.COUNTRIES.AQ"),
    AR: t("COMMON.COUNTRIES.AR"),
    AS: t("COMMON.COUNTRIES.AS"),
    AT: t("COMMON.COUNTRIES.AT"),
    AU: t("COMMON.COUNTRIES.AU"),
    AW: t("COMMON.COUNTRIES.AW"),
    AX: t("COMMON.COUNTRIES.AX"),
    AZ: t("COMMON.COUNTRIES.AZ"),
    BA: t("COMMON.COUNTRIES.BA"),
    BB: t("COMMON.COUNTRIES.BB"),
    BD: t("COMMON.COUNTRIES.BD"),
    BE: t("COMMON.COUNTRIES.BE"),
    BF: t("COMMON.COUNTRIES.BF"),
    BG: t("COMMON.COUNTRIES.BG"),
    BH: t("COMMON.COUNTRIES.BH"),
    BI: t("COMMON.COUNTRIES.BI"),
    BJ: t("COMMON.COUNTRIES.BJ"),
    BL: t("COMMON.COUNTRIES.BL"),
    BM: t("COMMON.COUNTRIES.BM"),
    BN: t("COMMON.COUNTRIES.BN"),
    BO: t("COMMON.COUNTRIES.BO"),
    BQ: t("COMMON.COUNTRIES.BQ"),
    BR: t("COMMON.COUNTRIES.BR"),
    BS: t("COMMON.COUNTRIES.BS"),
    BT: t("COMMON.COUNTRIES.BT"),
    BV: t("COMMON.COUNTRIES.BV"),
    BW: t("COMMON.COUNTRIES.BW"),
    BY: t("COMMON.COUNTRIES.BY"),
    BZ: t("COMMON.COUNTRIES.BZ"),
    CA: t("COMMON.COUNTRIES.CA"),
    CC: t("COMMON.COUNTRIES.CC"),
    CD: t("COMMON.COUNTRIES.CD"),
    CF: t("COMMON.COUNTRIES.CF"),
    CG: t("COMMON.COUNTRIES.CG"),
    CH: t("COMMON.COUNTRIES.CH"),
    CI: t("COMMON.COUNTRIES.CI"),
    CK: t("COMMON.COUNTRIES.CK"),
    CL: t("COMMON.COUNTRIES.CL"),
    CM: t("COMMON.COUNTRIES.CM"),
    CN: t("COMMON.COUNTRIES.CN"),
    CO: t("COMMON.COUNTRIES.CO"),
    CR: t("COMMON.COUNTRIES.CR"),
    CU: t("COMMON.COUNTRIES.CU"),
    CV: t("COMMON.COUNTRIES.CV"),
    CW: t("COMMON.COUNTRIES.CW"),
    CX: t("COMMON.COUNTRIES.CX"),
    CY: t("COMMON.COUNTRIES.CY"),
    CZ: t("COMMON.COUNTRIES.CZ"),
    DE: t("COMMON.COUNTRIES.DE"),
    DJ: t("COMMON.COUNTRIES.DJ"),
    DK: t("COMMON.COUNTRIES.DK"),
    DM: t("COMMON.COUNTRIES.DM"),
    DO: t("COMMON.COUNTRIES.DO"),
    DZ: t("COMMON.COUNTRIES.DZ"),
    EC: t("COMMON.COUNTRIES.EC"),
    EE: t("COMMON.COUNTRIES.EE"),
    EG: t("COMMON.COUNTRIES.EG"),
    EH: t("COMMON.COUNTRIES.EH"),
    ER: t("COMMON.COUNTRIES.ER"),
    ES: t("COMMON.COUNTRIES.ES"),
    ET: t("COMMON.COUNTRIES.ET"),
    FI: t("COMMON.COUNTRIES.FI"),
    FJ: t("COMMON.COUNTRIES.FJ"),
    FK: t("COMMON.COUNTRIES.FK"),
    FM: t("COMMON.COUNTRIES.FM"),
    FO: t("COMMON.COUNTRIES.FO"),
    FR: t("COMMON.COUNTRIES.FR"),
    GA: t("COMMON.COUNTRIES.GA"),
    GB: t("COMMON.COUNTRIES.GB"),
    GD: t("COMMON.COUNTRIES.GD"),
    GE: t("COMMON.COUNTRIES.GE"),
    GF: t("COMMON.COUNTRIES.GF"),
    GG: t("COMMON.COUNTRIES.GG"),
    GH: t("COMMON.COUNTRIES.GH"),
    GI: t("COMMON.COUNTRIES.GI"),
    GL: t("COMMON.COUNTRIES.GL"),
    GM: t("COMMON.COUNTRIES.GM"),
    GN: t("COMMON.COUNTRIES.GN"),
    GP: t("COMMON.COUNTRIES.GP"),
    GQ: t("COMMON.COUNTRIES.GQ"),
    GR: t("COMMON.COUNTRIES.GR"),
    GS: t("COMMON.COUNTRIES.GS"),
    GT: t("COMMON.COUNTRIES.GT"),
    GU: t("COMMON.COUNTRIES.GU"),
    GW: t("COMMON.COUNTRIES.GW"),
    GY: t("COMMON.COUNTRIES.GY"),
    HK: t("COMMON.COUNTRIES.HK"),
    HM: t("COMMON.COUNTRIES.HM"),
    HN: t("COMMON.COUNTRIES.HN"),
    HR: t("COMMON.COUNTRIES.HR"),
    HT: t("COMMON.COUNTRIES.HT"),
    HU: t("COMMON.COUNTRIES.HU"),
    IC: t("COMMON.COUNTRIES.IC"),
    ID: t("COMMON.COUNTRIES.ID"),
    IE: t("COMMON.COUNTRIES.IE"),
    IL: t("COMMON.COUNTRIES.IL"),
    IM: t("COMMON.COUNTRIES.IM"),
    IN: t("COMMON.COUNTRIES.IN"),
    IO: t("COMMON.COUNTRIES.IO"),
    IQ: t("COMMON.COUNTRIES.IQ"),
    IR: t("COMMON.COUNTRIES.IR"),
    IS: t("COMMON.COUNTRIES.IS"),
    IT: t("COMMON.COUNTRIES.IT"),
    JE: t("COMMON.COUNTRIES.JE"),
    JM: t("COMMON.COUNTRIES.JM"),
    JO: t("COMMON.COUNTRIES.JO"),
    JP: t("COMMON.COUNTRIES.JP"),
    KE: t("COMMON.COUNTRIES.KE"),
    KG: t("COMMON.COUNTRIES.KG"),
    KH: t("COMMON.COUNTRIES.KH"),
    KI: t("COMMON.COUNTRIES.KI"),
    KM: t("COMMON.COUNTRIES.KM"),
    KN: t("COMMON.COUNTRIES.KN"),
    KP: t("COMMON.COUNTRIES.KP"),
    KR: t("COMMON.COUNTRIES.KR"),
    KW: t("COMMON.COUNTRIES.KW"),
    KY: t("COMMON.COUNTRIES.KY"),
    KZ: t("COMMON.COUNTRIES.KZ"),
    LA: t("COMMON.COUNTRIES.LA"),
    LB: t("COMMON.COUNTRIES.LB"),
    LC: t("COMMON.COUNTRIES.LC"),
    LI: t("COMMON.COUNTRIES.LI"),
    LK: t("COMMON.COUNTRIES.LK"),
    LR: t("COMMON.COUNTRIES.LR"),
    LS: t("COMMON.COUNTRIES.LS"),
    LT: t("COMMON.COUNTRIES.LT"),
    LU: t("COMMON.COUNTRIES.LU"),
    LV: t("COMMON.COUNTRIES.LV"),
    LY: t("COMMON.COUNTRIES.LY"),
    MA: t("COMMON.COUNTRIES.MA"),
    MC: t("COMMON.COUNTRIES.MC"),
    MD: t("COMMON.COUNTRIES.MD"),
    ME: t("COMMON.COUNTRIES.ME"),
    MF: t("COMMON.COUNTRIES.MF"),
    MG: t("COMMON.COUNTRIES.MG"),
    MH: t("COMMON.COUNTRIES.MH"),
    MK: t("COMMON.COUNTRIES.MK"),
    ML: t("COMMON.COUNTRIES.ML"),
    MM: t("COMMON.COUNTRIES.MM"),
    MN: t("COMMON.COUNTRIES.MN"),
    MO: t("COMMON.COUNTRIES.MO"),
    MP: t("COMMON.COUNTRIES.MP"),
    MQ: t("COMMON.COUNTRIES.MQ"),
    MR: t("COMMON.COUNTRIES.MR"),
    MS: t("COMMON.COUNTRIES.MS"),
    MT: t("COMMON.COUNTRIES.MT"),
    MU: t("COMMON.COUNTRIES.MU"),
    MV: t("COMMON.COUNTRIES.MV"),
    MW: t("COMMON.COUNTRIES.MW"),
    MX: t("COMMON.COUNTRIES.MX"),
    MY: t("COMMON.COUNTRIES.MY"),
    MZ: t("COMMON.COUNTRIES.MZ"),
    NA: t("COMMON.COUNTRIES.NA"),
    NC: t("COMMON.COUNTRIES.NC"),
    NE: t("COMMON.COUNTRIES.NE"),
    NF: t("COMMON.COUNTRIES.NF"),
    NG: t("COMMON.COUNTRIES.NG"),
    NI: t("COMMON.COUNTRIES.NI"),
    NL: t("COMMON.COUNTRIES.NL"),
    NO: t("COMMON.COUNTRIES.NO"),
    NP: t("COMMON.COUNTRIES.NP"),
    NR: t("COMMON.COUNTRIES.NR"),
    NU: t("COMMON.COUNTRIES.NU"),
    NZ: t("COMMON.COUNTRIES.NZ"),
    OM: t("COMMON.COUNTRIES.OM"),
    PA: t("COMMON.COUNTRIES.PA"),
    PE: t("COMMON.COUNTRIES.PE"),
    PF: t("COMMON.COUNTRIES.PF"),
    PG: t("COMMON.COUNTRIES.PG"),
    PH: t("COMMON.COUNTRIES.PH"),
    PK: t("COMMON.COUNTRIES.PK"),
    PL: t("COMMON.COUNTRIES.PL"),
    PM: t("COMMON.COUNTRIES.PM"),
    PN: t("COMMON.COUNTRIES.PN"),
    PR: t("COMMON.COUNTRIES.PR"),
    PS: t("COMMON.COUNTRIES.PS"),
    PT: t("COMMON.COUNTRIES.PT"),
    PW: t("COMMON.COUNTRIES.PW"),
    PY: t("COMMON.COUNTRIES.PY"),
    QA: t("COMMON.COUNTRIES.QA"),
    RE: t("COMMON.COUNTRIES.RE"),
    RO: t("COMMON.COUNTRIES.RO"),
    RS: t("COMMON.COUNTRIES.RS"),
    RU: t("COMMON.COUNTRIES.RU"),
    RW: t("COMMON.COUNTRIES.RW"),
    SA: t("COMMON.COUNTRIES.SA"),
    SB: t("COMMON.COUNTRIES.SB"),
    SC: t("COMMON.COUNTRIES.SC"),
    SD: t("COMMON.COUNTRIES.SD"),
    SE: t("COMMON.COUNTRIES.SE"),
    SG: t("COMMON.COUNTRIES.SG"),
    SH: t("COMMON.COUNTRIES.SH"),
    SI: t("COMMON.COUNTRIES.SI"),
    SJ: t("COMMON.COUNTRIES.SJ"),
    SK: t("COMMON.COUNTRIES.SK"),
    SL: t("COMMON.COUNTRIES.SL"),
    SM: t("COMMON.COUNTRIES.SM"),
    SN: t("COMMON.COUNTRIES.SN"),
    SO: t("COMMON.COUNTRIES.SO"),
    SR: t("COMMON.COUNTRIES.SR"),
    SS: t("COMMON.COUNTRIES.SS"),
    ST: t("COMMON.COUNTRIES.ST"),
    SV: t("COMMON.COUNTRIES.SV"),
    SX: t("COMMON.COUNTRIES.SX"),
    SY: t("COMMON.COUNTRIES.SY"),
    SZ: t("COMMON.COUNTRIES.SZ"),
    TC: t("COMMON.COUNTRIES.TC"),
    TD: t("COMMON.COUNTRIES.TD"),
    TF: t("COMMON.COUNTRIES.TF"),
    TG: t("COMMON.COUNTRIES.TG"),
    TH: t("COMMON.COUNTRIES.TH"),
    TJ: t("COMMON.COUNTRIES.TJ"),
    TK: t("COMMON.COUNTRIES.TK"),
    TL: t("COMMON.COUNTRIES.TL"),
    TM: t("COMMON.COUNTRIES.TM"),
    TN: t("COMMON.COUNTRIES.TN"),
    TO: t("COMMON.COUNTRIES.TO"),
    TR: t("COMMON.COUNTRIES.TR"),
    TT: t("COMMON.COUNTRIES.TT"),
    TV: t("COMMON.COUNTRIES.TV"),
    TW: t("COMMON.COUNTRIES.TW"),
    TZ: t("COMMON.COUNTRIES.TZ"),
    UA: t("COMMON.COUNTRIES.UA"),
    UG: t("COMMON.COUNTRIES.UG"),
    UM: t("COMMON.COUNTRIES.UM"),
    US: t("COMMON.COUNTRIES.US"),
    UY: t("COMMON.COUNTRIES.UY"),
    UZ: t("COMMON.COUNTRIES.UZ"),
    VA: t("COMMON.COUNTRIES.VA"),
    VC: t("COMMON.COUNTRIES.VC"),
    VE: t("COMMON.COUNTRIES.VE"),
    VG: t("COMMON.COUNTRIES.VG"),
    VI: t("COMMON.COUNTRIES.VI"),
    VN: t("COMMON.COUNTRIES.VN"),
    VU: t("COMMON.COUNTRIES.VU"),
    WF: t("COMMON.COUNTRIES.WF"),
    WS: t("COMMON.COUNTRIES.WS"),
    YE: t("COMMON.COUNTRIES.YE"),
    YT: t("COMMON.COUNTRIES.YT"),
    ZA: t("COMMON.COUNTRIES.ZA"),
    ZM: t("COMMON.COUNTRIES.ZM"),
    ZW: t("COMMON.COUNTRIES.ZW"),
};
function getCountryName(countryCode) {
    return CountryCodeLookupTable[countryCode];
}
export function createSortedListByName(countryCodeList) {
    var codes = [];
    for (var i = 0; i < countryCodeList.length; i++) {
        var code = countryCodeList[i];
        codes.push({ code: code, name: getCountryName(code) });
    }
    codes.sort(function (a, b) {
        if (a.name < b.name) {
            return -1;
        }
        else if (a.name > b.name) {
            return 1;
        }
        else {
            return 0;
        }
    });
    return codes;
}
